import { getUUID } from '../../uuid';
import { Command, CommandOperation } from './command';
import { MutateOperation } from './mutate-operation';

export class MutationCommand implements Command<MutateOperation<unknown>[]> {
  readonly id = getUUID();
  readonly op: CommandOperation = 'patch';

  constructor(
    public readonly key: string,
    public readonly path: string,
    public readonly payload: MutateOperation<unknown>[] = [],
  ) {}
}
